"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("../constant");

var _constant3 = require("./constant");

var _default = {
  PropTypes: {
    data: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      code: _propTypes.default.string,
      selectionType: _propTypes.default.string
    })),
    theme: _propTypes.default.string,
    viewType: _propTypes.default.string,
    tripTypeOutput: _propTypes.default.func,
    mobileHeaderLabel: _propTypes.default.string,
    prefillTripTypeCode: _propTypes.default.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    data: _constant3.DEFAULT_DATA,
    viewType: _constant2.DEVICE_TYPE.DESKTOP,
    mobileHeaderLabel: _constant3.HEADER_LABEL_MOBILE
  }
};
exports.default = _default;